import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Image, ScrollView } from 'react-native';
import { ms, s, vs } from '../../utils/responsive';
import { NavigationProp } from '@react-navigation/native';
import logo from '../../assets/logo.png';

interface WhatIsNextScreenProps {
  navigation: NavigationProp<any>;
}

const WhatIsNextScreen: React.FC<WhatIsNextScreenProps> = ({ navigation }) => {
  return (
    <View style={styles.container}>
      <ScrollView contentContainerStyle={styles.scrollContent} showsVerticalScrollIndicator={false}>
        <Image source={logo} style={styles.logo} resizeMode="contain" />
        <Text style={styles.welcomeTitle}>Welcome to Final Key!{"\n"}Your account is ready.</Text>
        <View style={styles.lightGreyBox}>
          <Text style={styles.bodyText}>
            Before you can unlock the full power of Final Key, there are just a few important steps to complete:
          </Text>
          <Text style={styles.sectionTitle}>Complete Your Profile</Text>
          <Text style={styles.bodyText}>
            Add your basic details so we can personalize your experience and keep everything organized for you and your loved ones.
          </Text>
          <Text style={styles.sectionTitle}>Select Your Successor</Text>
          <Text style={styles.bodyText}>
            Choose someone you trust to access your information when the time comes. You can update or change this person at any time.
          </Text>
          <Text style={styles.sectionTitle}>Choose Your Keyholder</Text>
          <Text style={styles.bodyText}>
            This is the person who can unlock specific parts of your data if needed. Like your successor, this can always be updated later.
          </Text>
          <Text style={styles.bodyText}>
            You don't have to make all these decisions right now—feel free to skip and come back when you're ready. You're in control.
          </Text>
          <Text style={styles.letsGo}>Let's get started!</Text>
        </View>
        <View style={styles.buttonSpacer} />
        <TouchableOpacity style={styles.nextButton} onPress={() => navigation.navigate('Profile')}>
          <Text style={styles.nextButtonText}>Next</Text>
        </TouchableOpacity>
        <View style={styles.bottomSpacer} />
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#29BFC0',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingTop: ms(60),
  },
  scrollContent: {
    alignItems: 'center',
    paddingBottom: ms(50),
  },
  logo: {
    width: s(125),
    height: s(125),
    marginBottom: ms(10),
  },
  welcomeTitle: {
    fontSize: ms(24, 0.3),
    fontWeight: 'bold',
    color: '#fff',
    marginBottom: ms(15),
    textAlign: 'center',
    width: '90%',
  },
  lightGreyBox: {
    width: '92%',
    alignSelf: 'center',
    backgroundColor: '#EFF2F5',
    borderTopLeftRadius: ms(30),
    borderTopRightRadius: ms(30),
    borderBottomLeftRadius: ms(30),
    borderBottomRightRadius: ms(30),
    paddingTop: ms(25),
    paddingBottom: ms(25),
    paddingLeft: ms(10),
    paddingRight: ms(10),
    alignItems: 'flex-start',
    minHeight: s(450),
    marginTop: ms(10),
  },
  sectionTitle: {
    fontSize: ms(18, 0.3),
    fontWeight: 'bold',
    color: '#F2994A',
    marginTop: ms(18),
    marginBottom: ms(4),
  },
  bodyText: {
    fontSize: ms(16, 0.3),
    color: '#1C2C4F',
    marginBottom: ms(8),
    textAlign: 'left',
  },
  letsGo: {
    fontSize: ms(22, 0.3),
    color: '#29BFC0',
    fontWeight: '600',
    marginTop: ms(18),
    textAlign: 'left',
  },
  buttonSpacer: {
    height: s(30),
  },
  nextButton: {
    backgroundColor: '#ffffff',
    width: '90%',
    height: s(50),
    borderRadius: ms(25),
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 0,
    marginBottom: 0,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  nextButtonText: {
    color: '#29BFC0',
    fontSize: ms(18, 0.3),
    fontWeight: 'bold',
    textAlign: 'center',
  },
  bottomSpacer: {
    height: s(50),
  },
});

export default WhatIsNextScreen; 